<template>
  <div class="native-select" :class="classes">
    <label class="ux-field-title" v-if="showLabel"
      >{{ label }}
      <span class="ux-required-marker" v-if="required">*</span></label
    >
    <div class="ux-field-description" v-if="showDescription">
      {{ description }}
    </div>
    <div class="ui-select-button" v-if="singleValue">
      <slot>
        <ux-button tag="div">
          {{ summary }}
        </ux-button>
      </slot>
    </div>
    <select @focus="touch" :multiple="multiValue" v-model="model">
      <option value="" v-if="singleValue && !minimum">None</option>
      <template :key="group.key" v-for="group in optionGroups">
        <optgroup :label="group.title">
          <option :value="option.value" v-for="option in group.options">
            {{ option.title }}
          </option>
        </optgroup>

        <!-- <optgroup :label="group.title" v-if="group.options.length > 1">
                    <option
                        :value="option.value"
                        v-for="option in group.options"
                    >
                        {{ option.title }}
                    </option>
                </optgroup>
                <template v-else>
                    <option
                        :value="option.value"
                        v-for="option in group.options"
                    >
                        {{ option.title }}
                    </option>
                </template> -->
      </template>
    </select>
  </div>
</template>
<script>
import InputMixin from "./input-mixin";

function isUndefined(entry) {
  return (
    entry === undefined ||
    typeof entry === "undefined" ||
    entry === null ||
    String(entry) === "null" ||
    String(entry) === "undefined"
  );
}

//////////////////////////

export default {
  props: {
    title: {
      type: String,
    },
    modelValue: {
      // type: [Object, Array],
    },
  },
  mixins: [InputMixin],
  async created() {
    this.model = this.model;

    await this.$glossary.ensure();
    var glossary = this.$glossary.items;
    this.hash = this.$glossary.hash;

    var typeList = glossary;

    if (this.field.defineableTypes) {
      typeList = typeList.filter(function (definition) {
        return definition.defineable;
      });
    } else {
      if (this.field.basicTypes === false) {
        typeList = typeList.filter(function (definition) {
          return !!definition.definesType;
        });
      }

      if (this.field.definedTypes === false) {
        typeList = typeList.filter(function (definition) {
          return !definition.definesType;
        });
      }
    }

    if (this.field.definedParentType) {
      var definedParentType = this.field.definedParentType;
      typeList = typeList.filter(function (definition) {
        return definition.definesType === definedParentType;
      });
    }

    ////////////////////////////

    typeList = typeList
      .map(function (definition) {
        return {
          title: definition.title,
          value: definition.key,
          definesType: definition.definesType,
        };
      })
      .sort((a, b) => (a.title > b.title ? 1 : -1));

    ////////////////////////////

    this.types = typeList;
  },
  data() {
    return {
      hash: {},
      types: [],
    };
  },
  methods: {
    cleanOutput(val) {
      var self = this;

      if (isUndefined(val)) {
        if (self.multiValue) {
          val = [];
        } else {
          val = undefined;
        }
      } else {
        if (self.multiValue) {
          val = (val || []).filter(Boolean).map(function (i) {
            return self.getValue(i);
          });
        } else {
          val = self.getValue(val);
        }
      }

      return val;
    },
    cleanInput(val) {
      var self = this;

      if (self.multiValue) {
        if (!val) {
          val = [];
        }

        if (!Array.isArray(val)) {
          val = [val];
        }

        /////////////////////////////////

        if (self.maximum) {
          if (val.length > self.maximum) {
            val.length = self.maximum;
          }
        }

        val = val.filter(Boolean).map(function (v) {
          var valueKey = self.getValue(v);
          return self.returnObject ? self.optionLookup[valueKey] : valueKey;
        });
      } else {
        var valueKey = self.getValue(val);
        val = self.returnObject ? self.optionLookup[valueKey] : valueKey;
      }

      return val;
    },
  },
  computed: {
    optionGroups() {
      const self = this;
      const mapped = self.selectableOptions.reduce(
        function (memo, type) {
          const typeKey = type.key || type.value;
          let parentTypeKey = type.definesType;

          if (!parentTypeKey) {
            memo["__basic"].options.push({
              title: type.title,
              value: type.key || type.value,
            });
          }

          parentTypeKey = parentTypeKey || typeKey;

          let existing = memo[parentTypeKey];
          if (!existing) {
            const parentType = self.hash[parentTypeKey];

            if (parentType) {
              existing = memo[parentTypeKey] = {
                title: parentType.plural,
                key: parentTypeKey,
                options: [],
              };
            } else {
              console.log("NO PARENT TYPE", parentTypeKey, self.hash);
            }
          }

          if (existing) {
            existing.options.push(type);
          }

          return memo;
        },
        {
          __basic: {
            key: "__basic",
            title: "Basic Types",
            options: [],
          },
        },
      );

      return Object.values(mapped)
        .filter(function (group) {
          if (!group.options.length) {
            return false;
          }
          if (group.options.length > 1) {
            return true;
          }

          if (group.options[0].value === group.key) {
            return false;
          }

          return true;
        })
        .sort(function (a, b) {
          var nA = (a.title || a).toLowerCase();

          if (a.key === "__basic") {
            return -1;
          }

          var nB = (b.title || b).toLowerCase();

          if (nA < nB) return -1;
          else if (nA > nB) return 1;
          return 0;
        });
    },
    returnObject() {
      return false;
    },
    classes() {
      var array = [];

      if (this.multiValue) {
        array.push("multiple");
      } else {
        array.push("single");
      }

      return array;
    },
    optionLookup() {
      var self = this;
      return self.types.reduce(function (set, option) {
        const key = self.getValue(option);
        set[key] = option;
        return set;
      }, {});
    },
    summary() {
      return this.model
        ? this.getLabel(this.optionLookup[this.model])
        : this.title || "Click to select";
    },

    selectableOptions() {
      return this.types;
      // return this.options
      // .sort(function(option) {
      //     return option.title;
      // });
      // if(this.type == 'reference') {

      // } else {

      // }
    },
  },
};
</script>
<style lang="scss" scoped>
.native-select {
  cursor: pointer;

  &.multiple {
    select {
      width: 100%;
      font-size: 1em;
      border: 1px solid rgba(#000, 0.1);
      appearance: none;

      &:focus {
        border: 1px solid var(--primary);
      }
    }
  }

  &.single {
    position: relative;

    .ui-select-button {
      position: relative;
      width: 100%;

      & > .ux-btn {
        display: block;
        text-align: left;
      }
    }

    select {
      cursor: pointer;
      opacity: 0;
      appearance: none;
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
    }
  }
}
</style>
